module.exports = __webpack_public_path__ + "img/outlet-banner.3b7b77f6.jpg";